function stripTrailingSlash(url: string): string {
  return url.replace(/\/$/, "");
}

/**
 * Resolve Patient Concierge API base URL for browser calls.
 *
 * 1. `PUBLIC_PATIENT_CONCIERGE_API_URL` when set
 * 2. On non-localhost hosts: `{PUBLIC_APIM_BASE_URL}/api/{slug}`
 * 3. Empty → relative `/api/*` (local Rsbuild proxy)
 */
export function patientConciergeApiBase(): string {
  if (typeof window !== "undefined") {
    const fromConfig =
      window.APP_CONFIG?.PUBLIC_PATIENT_CONCIERGE_API_URL?.trim() || "";
    if (fromConfig) return stripTrailingSlash(fromConfig);

    const apim = window.APP_CONFIG?.PUBLIC_APIM_BASE_URL?.trim() || "";
    const slug =
      window.APP_CONFIG?.PUBLIC_API_SERVICE_SLUG?.trim() || "patient-concierge";
    if (apim && window.location.hostname !== "localhost") {
      return `${stripTrailingSlash(apim)}/api/${slug}`;
    }
  }

  const fromEnv = (
    import.meta.env.PUBLIC_PATIENT_CONCIERGE_API_URL ?? ""
  ).trim();
  return stripTrailingSlash(fromEnv);
}

export function getBaseUrl(): string {
  if (typeof window !== "undefined") {
    return stripTrailingSlash(window.APP_CONFIG?.PUBLIC_APIM_BASE_URL || "");
  }
  return "";
}
